<template>
  <div>
    <base-swiper
      v-if="data.length > 0"
      ref="swiper"
      :data="data"
      lazy
      :slide-change="slideChange"
      :class="$style.swiper"
    >
      <template v-slot:default="slotProps">
        <img
          :data-src="slotProps.el.pic_url"
          :alt="slotProps.el.title"
          class="swiper-lazy"
        />
      </template>
    </base-swiper>
    <div :class="$style.cover">
      <button :class="$style.cover_prev" @click="onChange('prev')" />
      <button :class="$style.cover_next" @click="onChange('next')" />
    </div>
    <the-day-swiper-footer
      :index="pageIndex"
      :total="data.length"
      :title="data[pageIndex] && data[pageIndex].title"
      @change="onChange"
    />
  </div>
</template>

<script>
import BaseSwiper from '../BaseSwiper'
import TheDaySwiperFooter from './TheDaySwiperFooter'

export default {
  components: { BaseSwiper, TheDaySwiperFooter },
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      pageIndex: 0,
    }
  },
  methods: {
    slideChange(swiper) {
      this.pageIndex = swiper.realIndex
    },
    onChange(type) {
      switch (type) {
        case 'prev':
          this.$refs.swiper.slidePrev()
          break
        case 'next':
          this.$refs.swiper.slideNext()
          break
      }
    },
  },
}
</script>

<style lang="less" module>
@swiper-arrow-size: 0.76rem;
@swiper-arrow-margin: 0.24rem;

.swiper {
  .size(100%, @life-day-img-height);
  border-radius: 0 0.5rem 0 0.5rem;

  img {
    .size(100%);
  }
}

.cover {
  .size(100%, @life-day-img-height);
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  background-color: fade(#fff, 0%);

  &_prev,
  &_next {
    .size(50%, 100%);
    content: '';
    position: absolute;
    top: 0;
    background-color: transparent;

    &::after {
      .size(@swiper-arrow-size);
      position: absolute;
      top: 50%;
      background: url('./images/day-swiper-arrow.png') no-repeat;
      background-size: 200% 100%;
      transform: translateY(-50%);
    }

    &:hover {
      &::after {
        content: '';
      }
    }
  }

  &_prev {
    left: 0;

    &::after {
      left: @swiper-arrow-margin;
      background-position: 0 0;
    }
  }

  &_next {
    right: 0;

    &::after {
      right: @swiper-arrow-margin;
      background-position: 100% 0;
    }
  }
}

@media screen and (max-width: @tablet-width) {
  .swiper {
    height: @life-day-img-height * @life-day-tablet;
  }

  .cover {
    height: @life-day-img-height * @life-day-tablet;

    &_prev,
    &_next {
      &::after {
        .size(@swiper-arrow-size * @life-day-tablet);
      }
    }

    &_prev {
      &::after {
        left: @swiper-arrow-margin * @life-day-tablet;
      }
    }

    &_next {
      &::after {
        right: @swiper-arrow-margin * @life-day-tablet;
      }
    }
  }
}

@media screen and (max-width: @mini-width) {
  .swiper {
    height: @life-day-img-height * @life-day-mini;
  }

  .cover {
    height: @life-day-img-height * @life-day-mini;

    &_prev,
    &_next {
      &::after {
        .size(@swiper-arrow-size * @life-day-mini);
      }
    }

    &_prev {
      &::after {
        left: @swiper-arrow-margin * @life-day-mini;
      }
    }

    &_next {
      &::after {
        right: @swiper-arrow-margin * @life-day-mini;
      }
    }
  }
}
</style>
